module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "user-card"
  }, [_c('div', {
    staticClass: "user-info"
  }, [_c('div', {
    staticClass: "avathor"
  }, [(!_vm.isUnbind && _vm.userData.avatar.substr(0, 1) !== '?') ? _c('img', {
    attrs: {
      "src": _vm.userData.avatar
    }
  }) : _c('img', {
    attrs: {
      "src": require("../../images/personal_center/avatar_default.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "user-name"
  }, [_vm._v("\n                " + _vm._s(_vm.userData.nick_name) + "\n                "), (_vm.userData.is_official) ? _c('el-tooltip', {
    attrs: {
      "effect": "light",
      "content": "蓝鲸智云官方",
      "placement": "right"
    }
  }, [_c('svg', {
    staticStyle: {
      "width": "18px",
      "height": "18px",
      "vertical-align": "text-bottom"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-lanjingguanfang"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.userData.is_vip) ? _c('el-tooltip', {
    attrs: {
      "effect": "light",
      "content": "核心用户",
      "placement": "right"
    }
  }, [_c('span', {
    staticClass: "icon-vipuser"
  })]) : _vm._e()], 1), _vm._v(" "), (_vm.isUnbind) ? _c('div', [_vm._v("该用户已注销")]) : [_c('div', {
    staticClass: "user-desc"
  }, [_vm._v(_vm._s(_vm.userData.signature_label || '这个人很懒，什么都没有留下'))]), _vm._v(" "), _c('div', {
    staticClass: "user-jion"
  }, [_vm._v("加入时间：" + _vm._s(_vm.userData.register_time))]), _vm._v(" "), _c('ul', {
    staticClass: "user-awards"
  }, _vm._l((_vm.honorList), function(item, index) {
    return _c('li', {
      key: index,
      attrs: {
        "title": item.medal.name
      }
    }, [_c('img', {
      staticStyle: {
        "width": "20px",
        "height": "20px"
      },
      attrs: {
        "src": item.medal.icon_on,
        "alt": ""
      }
    })])
  }), 0)]], 2), _vm._v(" "), (_vm.follow.is_mutual_follow) ? _c('el-button', {
    staticClass: "user-attention",
    staticStyle: {
      "background": "#989ba5",
      "color": "#fff"
    },
    on: {
      "click": _vm.unfollowUser
    }
  }, [_c('span', {
    staticClass: "display"
  }, [_vm._v("相互关注")]), _vm._v(" "), _c('span', {
    staticClass: "hover-display"
  }, [_vm._v("取消关注")])]) : [(_vm.follow.is_followed) ? _c('el-button', {
    staticClass: "user-attention",
    on: {
      "click": _vm.unfollowUser
    }
  }, [_c('span', {
    staticClass: "display"
  }, [_vm._v("已关注")]), _vm._v(" "), _c('span', {
    staticClass: "hover-display"
  }, [_vm._v("取消关注")])]) : _c('el-button', {
    staticClass: "user-attention",
    staticStyle: {
      "background": "#989ba5",
      "color": "#fff"
    },
    attrs: {
      "type": _vm.disable ? 'default' : 'primary',
      "disabled": _vm.isUnbind || _vm.disable,
      "icon": "el-icon-plus"
    },
    on: {
      "click": _vm.followUser
    }
  }, [_vm._v("关注")])]], 2), _vm._v(" "), _c('div', {
    staticClass: "user-dynamic"
  }, [(!_vm.isUnbind) ? _vm._l((_vm.dynamicData), function(item) {
    return _c('div', {
      key: item.name,
      staticClass: "dynamic-list"
    }, [_c('p', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('p', {
      staticClass: "nums",
      on: {
        "click": function($event) {
          return _vm.goToPage(item)
        }
      }
    }, [_vm._v(_vm._s(item.nums))])])
  }) : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-7874d55a!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/common/userCard.vue
// module id = gFXL
// module chunks = 15